import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import { BillingTriggerType } from '~/types/api.model';
import { makeFixedCost, makeRangeCost, makeVariableCost } from '../service-cost';
import { ServiceIntegrationsModel } from '../ServiceIntegrations';
import { ServiceTemplateStatus } from './model';
export const generateId = ()=>generateUniqueId('service-template');
export function clone(input) {
    return _object_spread_props(_object_spread({}, input), {
        id: generateId()
    });
}
export function makeServiceTemplate(input) {
    var _input_terms;
    return {
        id: input.id != null ? input.id : generateId(),
        name: input.name,
        description: input.description,
        terms: (_input_terms = input.terms) !== null && _input_terms !== void 0 ? _input_terms : '',
        status: input.status || ServiceTemplateStatus.Active,
        cost: input.cost,
        billing: input.billing,
        origin: input.origin || null,
        integrations: input.integrations || ServiceIntegrationsModel.fromDTO(undefined),
        usedIn: input.usedIn || [],
        taxable: input.taxable,
        bundle: input.bundle
    };
}
export { makeFixedCost, makeRangeCost, makeVariableCost };
export function makeBillingOnApproval() {
    return {
        trigger: BillingTriggerType.OnApproval
    };
}
export function makeBillingOneTimeManual() {
    return {
        trigger: BillingTriggerType.OneTimeManual
    };
}
export function makeBillingOngoing(recurrencePeriod) {
    return {
        trigger: BillingTriggerType.Ongoing,
        recurrencePeriod
    };
}
export function makeBillingRepeatableManual(recurrencePeriod) {
    return {
        trigger: BillingTriggerType.RepeatableManual,
        recurrencePeriod
    };
}
export function makeBillingOneTimeInStages(oneTimeInStages) {
    return {
        trigger: BillingTriggerType.OneTimeInStages,
        oneTimeInStages
    };
}
export function makeBillingOnDemand(preapprovalPeriod) {
    return {
        trigger: BillingTriggerType.OnDemand,
        preapprovalPeriod
    };
}
